import { render, staticRenderFns } from "./Nivel3.vue?vue&type=template&id=be09e174&"
import script from "./Nivel3.vue?vue&type=script&lang=js&"
export * from "./Nivel3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports